export default __webpack_public_path__ + "static/media/secondarycard2@3x.533defc9.png";